/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} My_Grower_Report_Last_MonthInputs */

const vi_my_grower_report_last_month = /** @type {(inputs: My_Grower_Report_Last_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tháng trước (${i?.month})`)
};

/**

* @param {My_Grower_Report_Last_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_last_month = /** @type {((inputs: My_Grower_Report_Last_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Last_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_last_month(inputs)
});